import { Injectable } from '@angular/core';
import { catchErrorTo } from '@lycoris-nubila/ngx-lycoris';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApplicationAdapter } from 'application/application.adapter';
import { UserTaskExportTaskStatus } from 'user/model/user-task-export-task-status';
import { UserApiPort } from 'user/port/user-api.port';
import { UserApplicationPort } from 'user/port/user-application.port';
import { UserSessionPort } from 'user/port/user-session.port';
import { CanExportUserMeetingsQuery } from 'user/query/task-export-task/can-export-user-meetings.query';
import { ObserveUserTaskExportTasksByCriteriaQuery } from 'user/query/task-export-task/observe-user-task- export-tasks-by-criteria.query';
import { SearchUserTaskExportTasksQuery } from 'user/query/task-export-task/search-user-task-export-tasks.query';
import {
	IUserTaskExportTask,
	UserTaskExportTask,
} from 'user/taskExportTask/user-task-export-task';
import { UserTaskExportTaskRepository } from 'user/taskExportTask/user-task-export-task.repository';
import { UserTaskExportTaskCommandHandler } from 'user/user-task-export-task-command.handler';

@Injectable({ providedIn: 'root' })
export class UserTaskExportTaskQueryHandler extends ApplicationAdapter {
	constructor(
		translateService: TranslateService,
		private _userApiPort: UserApiPort,
		private _userSessionPort: UserSessionPort,
		private _userApplicationPort: UserApplicationPort,
		private _userTaskExportTaskRepository: UserTaskExportTaskRepository,
		private _userTaskExportTaskCommandHandler: UserTaskExportTaskCommandHandler
	) {
		super(translateService);
	}

	public observeUserTaskExportTask(id: string): Observable<UserTaskExportTask> {
		return this._userTaskExportTaskRepository.observeUserTaskExportTaskById(id);
	}

	public canExportUserMeetings(
		query: CanExportUserMeetingsQuery
	): Observable<UserTaskExportTaskStatus> {
		return this._userApiPort.canExportUserMeetings(query);
	}
}
